export enum EChangeType {
  create = "create",
  update = "update",
  delete = "delete"
}